import { Core } from '../../Constants';
export function Mixin(Base) {
    return class StatusCodeDescription extends Base {
        get code() {
            return this.getNumber(Core.Vocab('code'));
        }
        get description() {
            return this.getString(Core.Vocab('description')) || '';
        }
    };
}
export const shouldApply = (res) => res.types.contains(Core.Vocab('StatusCodeDescription'));
//# sourceMappingURL=StatusCodeDescription.js.map